import React from 'react';
import Text from '../../../../../../v2BaseComponents/Text';
import PressableDynamicOpacity from '../../../../../../v2BaseComponents/PressableDynamicOpacity';
import { View } from 'react-native';
import { colors } from '../../../../../../../utils/theme';
import { getSpacing } from '../../../../../../../utils/spacing';

type SuggestionProps = {
    text: string;
    onPress: () => void;
};

const Suggestion: React.FC<SuggestionProps> = ({ text, onPress }) => {
    return (
        <PressableDynamicOpacity onPress={onPress} style={{}}>
            <View
                style={{
                    paddingVertical: getSpacing(6),
                    paddingHorizontal: getSpacing(8),
                    backgroundColor: colors['Chat-User-Message'],
                    borderRadius: 10,
                }}
            >
                <Text variant="subtitle-2" alignText="center">
                    {text}
                </Text>
            </View>
        </PressableDynamicOpacity>
    );
};

export default React.memo(Suggestion);
